import { render } from "./features-item.vue?vue&type=template&id=19057586&lang=true"
import script from "./features-item.vue?vue&type=script&lang=js"
export * from "./features-item.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__